import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { IconComponent } from '@ui';
import { IndicatorState } from '../../../models/indicator.models';
import { IndicatorStates } from '../../../constants/indicators.constants';

@Component({
  selector: 'ui-wave-quality-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    @if (isDisabled()) {
      <span class="text-black">--</span>
    } @else {
      @if (!isSignalHealthy()) {
        <ui-icon icon="close-circle" [class]="'text-red-400 text-md'" />
      } @else {
        <ui-icon icon="check-circle" [class]="'text-green text-md'" />
      }
    }
  `,
})
export class WaveQualityIndicatorComponent {
  state = input<IndicatorState>(IndicatorStates.Default);
  isSignalHealthy = input<boolean>();

  isDisabled = computed(
    () =>
      this.state() === IndicatorStates.Disabled ||
      this.isSignalHealthy() === null
  );
}
